import React from 'react';
import { Link } from 'react-router-dom';
import { Spinner } from '../../components/ui';
import { fullName } from '../../utils/helpers';
import FamilyMemberForm from '../members/FamilyMemberForm';

// Phone Families — one card per household, tap to open it and manage members.
export default function FamiliesMobile({ vm }) {
  const {
    canView, canEdit, canDelete, loading, families, totals, rows, q, setQ,
    openFamily, setOpenFamily, addingTo, setAddingTo, addMember, removeMember, detachMember,
  } = vm;

  if (!canView) {
    return (
      <div>
        <div className="page-head"><h1>Families</h1></div>
        <div className="card card-pad empty">You do not have access to the guests of this event.</div>
      </div>
    );
  }

  return (
    <div>
      <div className="page-head">
        <h1>Families</h1>
        <span className="muted">{totals.families} · {totals.people} people</span>
      </div>
      <div style={{ display: 'flex', gap: 8, marginBottom: 10 }}>
        <input placeholder="Search…" value={q} onChange={e => setQ(e.target.value)}
          style={{ flex: 1, padding: 11, border: '1px solid var(--line)', borderRadius: 10, fontSize: 16 }} />
        <Link className="btn primary" style={{ padding: '11px 14px' }} to="/app/members">+ Family</Link>
      </div>

      {loading ? <div className="card card-pad"><Spinner /></div>
        : families.length === 0 ? (
          <div className="card card-pad empty">
            No families yet. On Guests tap “Add Family” — the head alone is enough, members can be added here later.
          </div>
        ) : families.map(fam => {
          const open = openFamily === fam.familyId;
          return (
            <div key={fam.familyId} className="card card-pad" style={{ marginBottom: 8 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}
                onClick={() => setOpenFamily(open ? null : fam.familyId)}>
                <div style={{ minWidth: 0 }}>
                  <strong>{open ? '▾ ' : '▸ '}{fam.headName}</strong>
                  <div className="muted" style={{ fontSize: 12.5 }}>
                    {fam.head?.MobileNumber || 'no number'} · {fam.size} {fam.size === 1 ? 'person' : 'people'}
                  </div>
                </div>
                <div style={{ flex: 1 }} />
                {canEdit && fam.mine && (
                  <button className="btn light sm" onClick={(e) => { e.stopPropagation(); setAddingTo(fam.head); }}>+ Member</button>
                )}
              </div>

              {open && (
                <div style={{ marginTop: 8 }}>
                  <div className="muted" style={{ fontSize: 12, marginBottom: 6 }}>
                    Invited to {fam.functionNames.join(', ') || '—'}
                  </div>
                  {fam.members.length === 0 ? (
                    <div className="muted" style={{ fontSize: 12.5 }}>
                      Only the head so far — one card, one name printed.
                    </div>
                  ) : fam.members.map(m => (
                    <div key={m.GuestId} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '6px 0', borderTop: '1px solid var(--line)' }}>
                      <div style={{ minWidth: 0 }}>
                        <div>{fullName(m)}</div>
                        <div className="muted" style={{ fontSize: 12 }}>{m.MobileNumber || 'no number'}</div>
                      </div>
                      <div style={{ flex: 1 }} />
                      {canEdit && fam.mine && <button className="btn light sm" onClick={() => detachMember(m)}>Move out</button>}
                      {canDelete && fam.mine && <button className="btn danger sm" onClick={() => removeMember(m)}>✕</button>}
                    </div>
                  ))}
                </div>
              )}
            </div>
          );
        })}

      {addingTo && (
        <FamilyMemberForm
          head={addingTo} rows={rows}
          onClose={() => setAddingTo(null)}
          onSave={(payload) => addMember(addingTo, payload)}
        />
      )}
    </div>
  );
}
